import { render, staticRenderFns } from "./RPIndex.vue?vue&type=template&id=5886bc14"
import script from "./RPIndex.vue?vue&type=script&lang=js"
export * from "./RPIndex.vue?vue&type=script&lang=js"
import style0 from "./RPIndex.vue?vue&type=style&index=0&id=5886bc14&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports